export class Settings {
    
}

export class SettingsType {
    static MOTIVATIONS:string = 'MOTIVATIONS'
    static ENTRANCE:string = 'ENTRANCE'
}